import { Container } from '@mantine/core';
import { ReactNode } from 'react';

interface CustomContainerProps {
  children: ReactNode;
}

const CustomContainer: React.FC<CustomContainerProps> = ({ children }) => {
  return (
    <Container
      fluid
      className="relative rounded-xl bg-white border-2 border-solid border-[#F2F4F7]"
      p={40}
      mx={0}
      style={{
        boxShadow: '0px 10px 60px 0px rgba(226, 236, 249, 0.50)',
      }}
    >
      {children}
    </Container>
  );
};

export default CustomContainer;
